export const useStoreEvents = defineStore('StoreEvents', {
    state: () => ({
        events: null,
        error: null,
        filter: {
            paginate: {
                auto: false,
            },
        },
    }),
    actions: {
        async initEvents() {
            if (this.events) return Promise.resolve(this.events);
            return this.getEvents();
        },
        async getEvents() {
            this.error = null;
            ({events: this.events, error: this.error} = await useQueryEvents().get(this.filter));
        },
    },
    getters: {
        filterEvents() {
            return ({featured, minVideos, limitTo}) => {
                let events = [];
                if (!this.events) return events;
                events = this.events.filter(
                    (event) =>
                        (featured === undefined || event.event_featured === featured) &&
                        (minVideos === undefined || event.event_videos >= minVideos),
                );
                return limitTo ? events.slice(0, limitTo) : events;
            };
        },
        searchEvents() {
            return ({eventTitle}) => {
                if (!this.events) return [];
                return this.events.filter((event) =>
                    event.event_title.toLowerCase().includes(eventTitle.toLowerCase()),
                );
            };
        },
    },
});
